/* src/app/talentpool-insights/report-details/report-details.component.scss */
.margin-auto {
  margin: auto !important;
}
.wc-my-auto {
  margin-bottom: auto !important;
  margin-top: auto !important;
}
.ml--1 {
  margin-left: -1px;
}
.ml--2 {
  margin-left: -2px;
}
.ml--3 {
  margin-left: -3px;
}
.ml--4 {
  margin-left: -4px;
}
.ml--5 {
  margin-left: -5px;
}
.ml--6 {
  margin-left: -6px;
}
.ml--7 {
  margin-left: -7px;
}
.ml--8 {
  margin-left: -8px;
}
.ml--9 {
  margin-left: -9px;
}
.ml--10 {
  margin-left: -10px;
}
.ml--15 {
  margin-left: -15px;
}
.mr--5 {
  margin-right: -5px;
}
.mr--10 {
  margin-right: -10px;
}
.mr--15 {
  margin-right: -15px;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.mt-0 {
  margin-top: 0 !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.ml-0 {
  margin-left: 0 !important;
}
.mr-0 {
  margin-right: 0 !important;
}
.m-1 {
  margin: 5px !important;
}
.my-1 {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.mx-1 {
  margin-left: 5px !important;
  margin-right: 5px !important;
}
.mt-1 {
  margin-top: 5px !important;
}
.mb-1 {
  margin-bottom: 5px !important;
}
.ml-1 {
  margin-left: 5px !important;
}
.mr-1 {
  margin-right: 5px !important;
}
.mb-1-5 {
  margin-bottom: 7.5px !important;
}
.m-2 {
  margin: 10px !important;
}
.my-2 {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.mx-2 {
  margin-left: 10px !important;
  margin-right: 10px !important;
}
.mt-2 {
  margin-top: 10px !important;
}
.mb-2 {
  margin-bottom: 10px !important;
}
.ml-2 {
  margin-left: 10px !important;
}
.mr-2 {
  margin-right: 10px !important;
}
.m-3 {
  margin: 15px !important;
}
.my-3 {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}
.mx-3 {
  margin-left: 15px !important;
  margin-right: 15px !important;
}
.mt-3 {
  margin-top: 15px !important;
}
.mb-3 {
  margin-bottom: 15px !important;
}
.ml-3 {
  margin-left: 15px !important;
}
.mr-3 {
  margin-right: 15px !important;
}
.m-4 {
  margin: 20px !important;
}
.my-4 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}
.mx-4 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}
.mt-4 {
  margin-top: 20px !important;
}
.mb-4 {
  margin-bottom: 20px !important;
}
.ml-4 {
  margin-left: 20px !important;
}
.mr-4 {
  margin-right: 20px !important;
}
.m-5 {
  margin: 25px !important;
}
.my-5 {
  margin-top: 25px !important;
  margin-bottom: 25px !important;
}
.mx-5 {
  margin-left: 25px !important;
  margin-right: 25px !important;
}
.mt-5 {
  margin-top: 25px !important;
}
.mb-5 {
  margin-bottom: 25px !important;
}
.ml-5 {
  margin-left: 25px !important;
}
.mr-5 {
  margin-right: 25px !important;
}
.m-6 {
  margin: 30px !important;
}
.my-6 {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}
.mx-6 {
  margin-left: 30px !important;
  margin-right: 30px !important;
}
.mt-6 {
  margin-top: 30px !important;
}
.mb-6 {
  margin-bottom: 30px !important;
}
.ml-6 {
  margin-left: 30px !important;
}
.mr-6 {
  margin-right: 30px !important;
}
.mb-8 {
  margin-bottom: 40px !important;
}
.p-0 {
  padding: 0 !important;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.pt-0 {
  padding-top: 0 !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.pr-0 {
  padding-right: 0 !important;
}
.p-1 {
  padding: 5px !important;
}
.py-1 {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.px-1 {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.pt-1 {
  padding-top: 5px !important;
}
.pb-1 {
  padding-bottom: 5px !important;
}
.pl-1 {
  padding-left: 5px !important;
}
.pr-1 {
  padding-right: 5px !important;
}
.p-2 {
  padding: 10px !important;
}
.py-2 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.px-2 {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.pt-2 {
  padding-top: 10px !important;
}
.pb-2 {
  padding-bottom: 10px !important;
}
.pl-2 {
  padding-left: 10px !important;
}
.pr-2 {
  padding-right: 10px !important;
}
.p-3 {
  padding: 15px !important;
}
.py-3 {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.px-3 {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.pt-3 {
  padding-top: 15px !important;
}
.pb-3 {
  padding-bottom: 15px !important;
}
.pl-3 {
  padding-left: 15px !important;
}
.pr-3 {
  padding-right: 15px !important;
}
.p-4 {
  padding: 20px !important;
}
.py-4 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
.px-4 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.pt-4 {
  padding-top: 20px !important;
}
.pb-4 {
  padding-bottom: 20px !important;
}
.pl-4 {
  padding-left: 20px !important;
}
.pr-4 {
  padding-right: 20px !important;
}
.p-5 {
  padding: 25px !important;
}
.py-5 {
  padding-top: 25px !important;
  padding-bottom: 25px !important;
}
.px-5 {
  padding-left: 25px !important;
  padding-right: 25px !important;
}
.pt-5 {
  padding-top: 25px !important;
}
.pb-5 {
  padding-bottom: 25px !important;
}
.pl-5 {
  padding-left: 25px !important;
}
.pr-5 {
  padding-right: 25px !important;
}
.p-6 {
  padding: 30px !important;
}
.py-6 {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}
.px-6 {
  padding-left: 30px !important;
  padding-right: 30px !important;
}
.pt-6 {
  padding-top: 30px !important;
}
.pb-6 {
  padding-bottom: 30px !important;
}
.pl-6 {
  padding-left: 30px !important;
}
.pr-6 {
  padding-right: 30px !important;
}
.px-7 {
  padding-left: 35px !important;
  padding-right: 35px !important;
}
.py-7 {
  padding-top: 35px !important;
  padding-bottom: 35px !important;
}
.pb-7 {
  padding-bottom: 35px !important;
}
.px-8 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}
.py-8 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}
.pb-8 {
  padding-bottom: 40px !important;
}
.pt-8 {
  padding-top: 40px !important;
}
.text-justify {
  text-align: justify !important;
}
.text-wrap {
  white-space: normal !important;
}
.text-nowrap {
  white-space: nowrap !important;
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
.text-lowercase {
  text-transform: lowercase !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.font-weight-light {
  font-weight: 300 !important;
}
.font-weight-lighter {
  font-weight: lighter !important;
}
.font-weight-normal {
  font-weight: 400 !important;
}
.font-weight-500 {
  font-weight: 500 !important;
}
.font-weight-600 {
  font-weight: 600 !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.font-weight-bolder {
  font-weight: bolder !important;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  display: block;
  color: #000;
}
.text-blue {
  color: #2e93a1 !important;
}
.text-green {
  color: #229300;
}
.text-danger {
  color: #DE0000;
}
.text-defualt {
  color: #484b59;
  font-weight: 100;
}
.gray-text {
  color: #777777;
}
.text-light-grey {
  color: #949494 !important;
}
.text-white {
  color: #fff;
}
.text-black {
  color: #484b59 !important;
}
.text-orange {
  color: #FF9B05 !important;
}
.text-pink {
  color: #e85d75;
}
.text-dis {
  color: #CCCCCC;
}
.text-light-blue {
  color: #8fdde4;
}
.text-light-orange {
  color: #ffcd82;
}
.text-light-purple {
  color: #d6bdff;
}
.text-6767 {
  color: #676767;
}
.text-warning {
  color: #FFC400 !important;
}
a {
  color: #4dc7f4;
  outline: none;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  cursor: pointer;
  color: #4dc7f4;
}
.spacer {
  width: 1px;
  height: 1px;
}
.spacer2 {
  width: 1px;
}
.wc-d-block {
  display: block;
}
.wc-d-inline {
  display: inline;
}
.wc-d-inline-block {
  display: inline-block;
}
.wc-label {
  display: block;
  font-size: 14px;
  color: #000;
  padding-bottom: 5px;
}
.wc-form-control {
  border-radius: 2px;
  border: 2px solid #d6dde6;
  font-size: 14px;
  line-height: 1.2;
  padding: 6px 12px;
  height: 36px;
  width: 100%;
}
.wc-form-control:focus {
  border-color: #2e93a1;
  outline: none;
}
.wc-textarea {
  height: 100%;
}
.hr-color {
  border-bottom: 1px solid #676767;
}
.hr-color .wc-hr {
  display: inline;
}
.w-100 {
  width: 100%;
}
.h-15 {
  height: 18px;
}
.f-8 {
  font-size: 8px;
  line-height: 1.3;
}
.f-10 {
  font-size: 10px;
  line-height: 1.3;
}
.f-11 {
  font-size: 11px;
  line-height: 1.3;
}
.f-12 {
  font-size: 12px;
  line-height: 1.3;
}
.f-16 {
  font-size: 16px;
  line-height: 1.3;
}
.f-14 {
  font-size: 14px;
  line-height: 1.3;
}
.f-18 {
  font-size: 18px;
  line-height: 1.3;
}
.f-20 {
  font-size: 20px;
  line-height: 1.3;
}
.f-22 {
  font-size: 22px;
  line-height: 1.3;
}
.f-24 {
  font-size: 24px;
  line-height: 1.3;
}
.f-26 {
  font-size: 26px;
  line-height: 1.3;
}
.f-28 {
  font-size: 28px;
  line-height: 1.3;
}
.f-30 {
  font-size: 30px;
  line-height: 1.3;
}
.f-32 {
  font-size: 32px;
  line-height: 1.3;
}
.sep-tag {
  color: #676767;
  font-weight: 500;
  padding-bottom: 15px;
  background-color: #fff;
}
.category {
  color: #949494;
  font-weight: 500;
}
.wc-select {
  background-color: #fff;
  color: #676767;
}
.wc-select option {
  color: #484b59;
}
.wc-select option:disabled {
  color: #676767;
}
.wc-float-right {
  float: right;
}
.wc-float-left {
  float: left;
}
.wc-sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 60px;
  z-index: 1020;
  padding-top: 20px;
  padding-bottom: 40px;
  background-color: #fff;
  transition: all 0.3s;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.wc-upload-btn {
  width: 100px;
  height: 100px;
  border: 1px solid #777777;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  background-color: white;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.wc-upload-btn i {
  font-size: 16px;
  color: #2e93a1;
  position: relative;
  top: 45px;
  color: #2e93a1;
}
.wc-upload-btn .upload-sign {
  position: relative;
  top: 48px;
}
.wc-upload-btn input {
  position: absolute;
  cursor: pointer;
  font-size: 50px;
  opacity: 0;
  right: 0;
  top: 0;
}
.b {
  border: none;
}
.bl,
.bx {
  border-left: none;
}
.br,
.bx {
  border-right: none;
}
.bt,
.by {
  border-top: none;
}
.bb,
.by {
  border-bottom: none;
}
.wc-border {
  border: 1px solid #d1d1d1;
}
.wc-gray-border {
  border: 1px solid #484b59;
}
.br-0 {
  border-radius: inherit !important;
}
.brr-0 {
  border-top-right-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.brl-0 {
  border-top-left-radius: inherit !important;
  border-bottom-left-radius: inherit !important;
}
.brt-0 {
  border-top-left-radius: inherit !important;
  border-top-right-radius: inherit !important;
}
.brb-0 {
  border-bottom-left-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 16px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  background-color: white;
  border: 2px solid #777777;
  box-sizing: border-box;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: -1px;
  bottom: 0px;
  background-color: #777777;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: white;
  border-color: #80d7f8;
}
input:focus + .slider {
  box-shadow: 0 0 1px #80d7f8;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
  left: -10px;
  margin-right: -4px;
  background-color: #80d7f8;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.forms-top-header {
  width: calc(100% - 145px);
  position: fixed;
  top: 60px;
  margin: 0;
  padding: 20px 0 20px 0;
  background-color: #fff;
  z-index: 2;
}
.main-form {
  position: relative;
  top: 100px;
}
.wc-btn:hover {
  color: #ffffff;
  background-color: #206C79;
}
.wc-btn:focus {
  outline: none;
}
.wc-btn {
  padding: 7px 21px;
  color: #ffffff;
  font-weight: 100;
  border-radius: 2px;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-xs {
  padding: 3px 20px;
  border-radius: 16px;
  color: #ffffff;
  font-weight: 600;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-validate {
  background-color: #4a90e2;
}
.wc-btn-registered {
  background-color: #ffcd82;
}
.wc-primary {
  background-color: #2e93a1;
}
.wc-gray-btn {
  background-color: #999999;
}
.wc-white-btn {
  background-color: #fff;
  color: #484b59;
  border: 2px solid #d6dde6 !important;
}
.wc-primary {
  background-color: #2e93a1;
}
.line-height-1 {
  line-height: 1.6;
}
.line-height {
  line-height: 0px;
}
.hc {
  color: #484b59;
}
.bg-blue {
  background-color: #2E93A1;
}
.bg-blue-light {
  background-color: #b3e7fa;
}
.bg-blue-dark {
  background-color: #4a90e2;
}
.bg-blue-2 {
  background-color: #8fdde4;
}
.bg-orange {
  background-color: #FF9B05;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-gray {
  background-color: #fafafc !important;
}
.bg-gray-dark-2 {
  background-color: #d6dde6;
}
.bg-gray-dark {
  background-color: #d1d1d1;
}
.bg-gray-light {
  background-color: #fafafc;
}
.bg-red-light {
  background-color: #ead1d2;
}
.bg-red {
  background-color: #DE0000;
}
.bg-white {
  background-color: #ffffff;
}
.bg-green {
  background-color: #229300;
}
.bg-brawn {
  background-color: #cbaea5;
}
.bg-black {
  background-color: #484b59;
}
.nobg {
  background-color: transparent;
}
.btn-bg-black {
  background-color: #334059;
}
.btn-interview {
  padding: 8px 15px;
  letter-spacing: 4;
  color: #586e9a;
  border-radius: 2px;
  border: solid 1px #586e9a;
  transition: all 0.5s;
  background-color: #ffffff;
}
.btn-interview:hover,
.btn-interview:active,
.btn-interview:focus {
  color: #ffffff;
  border: solid 1px #586e9a;
  background-color: #586e9a;
}
.red-border {
  border: 1px solid #DE0000;
}
.blue-border {
  border: 1px solid #2e93a1;
}
.black-border {
  border: solid 1px #2C2C2C;
}
.border-stepper {
  border: solid 1px #334059;
}
.step-gray-border {
  border: solid 1px #d1d1d1;
}
.gt {
  color: #999999;
}
.text-blue-gray {
  color: #8094B1;
}
.light-blue-text {
  color: #012964;
}
.black-text {
  color: #000;
}
.green-text {
  color: #4ac98d;
}
.wccard {
  border-radius: 2px;
  background-color: #fff;
}
.wc-border {
  border: 2px solid #ECF0F4;
}
.wc-bl {
  border-left: 2px solid #ECF0F4;
}
.wc-br {
  border-right: 2px solid #ECF0F4;
}
.wc-bt {
  border-top: 2px solid #ECF0F4;
}
.wc-bb {
  border-bottom: 2px solid #ECF0F4;
}
.bg-warning {
  background-color: #FFC400;
}
.bg-light-green {
  background-color: #d3e9cc;
}
.bg-light-red {
  background-color: rgba(222, 0, 0, 0.2);
}
.paused-color {
  background-color: #FFF3CC;
}
.bg-img {
  background-color: #f5f6f9;
}
.hrcolor {
  border-top: 1px solid #ECF0F4;
}
.z-1 {
  z-index: -1;
}
.z0 {
  z-index: 0;
}
.z1 {
  z-index: 1;
}
.z2 {
  z-index: 2;
}
.z3 {
  z-index: 3;
}
.z4 {
  z-index: 4;
}
.z5 {
  z-index: 5;
}
.wc-box-shadow {
  box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
}
.pointer {
  cursor: pointer;
}
.c-logo {
  width: 50px;
  height: 50px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-mini {
  width: 30px;
  height: 30px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo-mini img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md {
  width: 80px;
  height: 80px;
  background-color: rgba(48, 5, 127, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 24px;
}
.c-logo-md img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md i {
  font-size: 40px;
}
.showpassword {
  position: absolute;
  top: 10px;
  right: 4%;
}
.listStyleBullet > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.listStyleBullet > ul li {
  padding: 2px 0;
}
.listStyleBullet div > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.strikethrough {
  text-decoration: line-through;
  color: #999999;
}
.anchor-text {
  color: #4dc7f4 !important;
}
.tl0 {
  top: 0;
  left: 0;
}
.tr0 {
  top: 0;
  right: 0;
}
.ats-cta-btn:hover i {
  color: #206C79;
}
.ats-cta-btn {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background-color: #D5E9EC;
  padding: 5px 8px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.ats-cta-btn i {
  color: #2E93A1;
  font-size: 14px;
  font-weight: 600;
}
.wc-progress-profile {
  background-color: rgba(103, 198, 187, 0.2);
  border-radius: 1rem;
}
.wc-progress-profile .wc-progress-bar {
  background-color: rgb(103, 198, 187);
}
.mt-3px {
  margin-top: 3px;
}
.mb-3px {
  margin-bottom: 1px;
}
label {
  font-size: 12px;
}
.no-outline {
  outline: none;
}
input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration {
  display: none;
}
.text-484b59 {
  color: #484b59;
}
.yrofexp {
  width: 160px;
  float: left;
}
.yrofexp input[type=number] {
  width: 60px;
  float: left;
  z-index: 2;
  position: relative;
  font-size: 14px;
}
.yrofexp input[type=text] {
  width: 90px;
  float: left;
  z-index: 2;
  margin-left: -2px;
  text-align: center;
}
.yrofexp input[type=text]:focus {
  border: 2px solid #d6dde6;
}
.yrofexp label {
  width: 100px;
  float: left;
  padding: 7.5px 12px;
  border: 2px solid #d6dde6;
  margin-left: -2px;
  border-radius: 0 2px 2px 0;
  color: #000;
  text-align: center;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
.form-control-sm::-webkit-inner-spin-button,
.form-control-sm::-webkit-outer-spin-button {
  -webkit-appearance: auto !important;
  appearance: auto !important;
  margin: 0;
}
.upload-container {
  width: 100%;
  float: left;
  height: 80px;
  color: #2e93a1;
  border: 2px solid #fafafc;
  cursor: pointer;
  position: relative;
  transition: 0.4s;
  border-radius: 2px;
}
.upload-container .upload--btn {
  width: 76px;
  height: 100%;
  padding: 22px 30px;
  background-color: #fafafc;
  font-size: 24px;
  position: absolute;
  transition: 0.4s;
  z-index: 2;
}
.upload-container .upload--section {
  width: 100%;
  text-align: left;
  position: absolute;
  left: 0;
  line-height: 76px;
  padding-left: 100px;
  transition: 0.4s;
  z-index: 0;
}
.upload-container input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.upload-container:hover {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
.upload-container:hover .upload--btn {
  background-color: #2e93a1;
  color: #fff;
  transition: 0.4s;
  z-index: 2;
}
.upload-container:hover .upload--section {
  background-color: #fafafc;
  color: #2e93a1;
  transition: 0.4s;
  z-index: 0;
}
.upload-container:focus {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
#b2bfd0 ::placeholder {
  color: red !important;
}
:-ms-input-placeholder {
  color: red !important;
}
::-ms-input-placeholder {
  color: red !important;
}
.genderBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.genderBtn .genderRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.genderBtn .genderText {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.genderBtn > input[type=radio]:checked + .genderText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  z-index: 2;
}
.wc-checkbox {
  width: 20px !important;
  height: 20px !important;
  position: relative;
  left: 0;
  top: 0;
  cursor: pointer;
}
.wc-checkbox input[type=checkbox] {
  left: 0;
  right: 0;
  width: 20px;
  height: 20px;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
}
.wc-radioBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.wc-radioBtn .teamRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.wc-radioBtn .teamText {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.wc-radioBtn > input[type=radio]:checked + .teamText,
.wc-radioBtn > input[type=checkbox]:checked + .teamText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  cursor: pointer;
}
.wc-ghostBtn {
  padding: 7px 21px;
  border: 1px solid #969696;
  background-color: #fff;
  color: #484b59;
  transition: 0.5s;
  outline: none;
  border-radius: 3px;
}
.wc-ghostBtn:hover {
}
.wc-ghostBtn:focus {
  color: #2e93a1;
  background-color: #fff;
}
.wc-ghostdisabled {
  color: #999999;
  border: 2px solid #999999;
  background-color: #fff;
  outline: none;
}
.wc-ghostBtnRed {
  border: 2px solid #DE0000;
  background-color: #fff;
  color: #DE0000;
  transition: 0.5s;
  outline: none;
}
.wc-ghostBtnRed:hover {
  color: #fff;
  background-color: #DE0000;
}
.wc-ghostBtnRed:focus {
  color: #fff;
  background-color: #DE0000;
}
@media only screen and (max-width: 1440px) {
  .wc-checkbox {
    width: 25px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1368px) {
  .wc-checkbox {
    width: 30px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1170px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media (max-width: 768px) {
  .modal-dialog {
    max-width: 700px;
    margin: 1.75rem auto;
  }
}
@media (max-width: 576px) {
  .modal-dialog {
    max-width: 95%;
    margin: 1.75rem auto;
  }
}
@media only screen and (max-width: 768px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 576px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
.ats-upload-btn {
  width: 100%;
  border: dashed 0.5px #b0bed2;
  color: #484b59;
  display: flex;
  box-sizing: border-box;
  position: relative;
}
.ats-upload-btn span {
  color: #d1d1d1;
  font-size: 34px;
  line-height: 1;
  z-index: 0;
}
.ats-upload-btn .ats--upload-cv,
.ats-upload-btn .ats--upload-linkedin {
  width: 50%;
  float: left;
  padding: 20px;
  border-right: 1px dashed #b0bed2;
  box-sizing: border-box;
  z-index: 0;
}
.ats-upload-btn .ats--upload-linkedin {
  border-right: none;
}
.ats-upload-btn input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.social-check {
  position: relative;
  cursor: pointer;
  margin-right: 10px;
}
.social-check input[type=checkbox] {
  width: 15px;
  height: 15px;
  opacity: 0;
}
.social-check i {
  font-size: 14px;
  position: absolute;
  left: 0;
  top: 0;
  color: #b2bfd0;
  cursor: pointer;
  transition: 0.5s;
}
.social-check input[type=checkbox]:checked + i {
  transition: 0.5s;
  color: #2e93a1;
}
input[type=month]::-webkit-inner-spin-button {
  display: none;
}
input[type=month]::-webkit-calendar-picker-indicator {
  opacity: 0;
  z-index: 2;
}
div.uploadFile {
  position: relative;
}
div.uploadFile input[type=file] {
  width: 100%;
  padding: 6px 12px;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  z-index: 2;
}
div.uploadFile span {
  position: absolute;
  left: 12px;
  top: 7px;
  z-index: 0;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 93%;
  white-space: nowrap;
}
div.uploadFile span i {
  color: #b2bfd0;
  cursor: pointer;
}
.custom-control-label::before {
  background-color: #fff;
  border: #2e93a1 solid 1px;
}
.custom-control-label::after {
  background-color: #2e93a1;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #2e93a1;
  background-color: #2e93a1;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  -webkit-transform: translateX(0.75rem);
  transform: translateX(0.75rem);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #2e93a1;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(48, 5, 127, 0.4);
}
.wc-can-cta .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
}
@media (max-width: 576px) {
  .ats-upload-btn {
    width: 100%;
    height: 100%;
    border: dashed 0.5px #b0bed2;
    color: #484b59;
    display: block;
    box-sizing: border-box;
    position: relative;
  }
  .ats-upload-btn span {
    color: #d1d1d1;
    font-size: 50px;
    line-height: 1;
    z-index: 0;
  }
  .ats-upload-btn .ats--upload-cv,
  .ats-upload-btn .ats--upload-linkedin {
    width: 100%;
    float: left;
    padding: 40px;
    border-right: 1px dashed #b0bed2;
    box-sizing: border-box;
    z-index: 0;
    display: block;
    border-bottom: 1px dashed #b0bed2;
  }
  .ats-upload-btn .ats--upload-linkedin {
    border-right: none;
    border-bottom: none;
  }
  .ats-upload-btn input {
    position: absolute;
    height: 100%;
    width: 100%;
    outline: none;
    cursor: pointer;
    opacity: 0;
    display: block;
  }
}
.bg-banner {
  background: url("./media/bg-image-ZQ6KMGTV.png");
  background-position: left top;
  background-size: cover;
  height: 100%;
}
.bg-banner .blueOverlay {
  position: absolute;
  opacity: 0.9;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 333;
  height: 100%;
}
.py-40 {
  padding-top: 45px;
}
.centeredForm {
  margin-top: 80px;
}
.logowidth {
  width: 45px;
  height: auto;
}
.wc-logotext {
  font-size: 30px;
  color: #fff;
}
.text-fafafa {
  color: #fafafa;
}
.iconDiv {
  width: 45px;
  float: left;
}
.textDiv {
  width: calc(100% - 45px);
  float: left;
}
.overlay {
  width: 100%;
  height: 80%;
  background-image:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgb(34, 53, 78));
  position: absolute;
  bottom: 0%;
}
.h100vh {
  height: 100vh;
}
#loginContainer {
  position: fixed;
  top: 0;
  left: 0;
}
@media only screen and (max-width: 600px) {
  .h100vh {
    height: 135vh;
  }
}
.logowidth {
  width: 35px;
  height: auto;
}
.wc-logotext {
  font-size: 22px;
  color: #FF9B05;
  vertical-align: -webkit-baseline-middle;
  line-height: 1;
  font-weight: 600;
}
.nav-pills .nav-link {
  border-radius: 3px;
  background-color: #F5F6F9;
}
.nav-link {
  display: block;
  padding: 0.5rem 2.5rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  font-weight: bold;
  background-color: #2e93a1;
}
.test {
  position: relative;
}
.test input[type=text] {
  background-color: transparent;
  z-index: 1;
}
.test .droparrow-down,
.test .droparrow-up {
  position: absolute;
  top: 9px;
  right: 15px;
  color: #d6dde6;
}
.test .fa-chevron-up {
  display: none;
}
input[type=text]:focus + .droparrow-down .fa-chevron-down {
  display: none;
  color: #2e93a1;
}
input[type=text]:focus + .droparrow-down .fa-chevron-up {
  display: block;
  color: #2e93a1;
}
.progress-c {
  width: 100px;
  height: 100px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
  border: 5px solid #fff;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2e93a1;
  font-weight: bold;
}
.wc-linked-btn-1,
.wc-uplaodrsume-btn-1 {
  width: 45%;
  float: left;
  color: #008bc2;
  border: 2px solid #008bc2;
  border-radius: 2px;
  margin-left: 15px;
  cursor: pointer;
}
.wc-linked-btn-1 .wc-linked-btn-i,
.wc-linked-btn-1 .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1 .wc-linked-btn-i,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  padding: 8px 9px;
  display: inline-flex;
  border-right: 2px solid #008bc2;
  justify-content: center;
}
.wc-linked-btn-1 .wc-linked-btn-t,
.wc-linked-btn-1 .wc-uplaodrsume-btn-t,
.wc-uplaodrsume-btn-1 .wc-linked-btn-t,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-t {
  padding: 3px 10px;
  display: inline-flex;
  justify-content: center;
  width: calc(100% - 36px);
}
.wc-linked-btn-1:hover,
.wc-uplaodrsume-btn-1:hover {
  color: #ffffff;
  background: #008bc2;
  border: 2px solid transparent;
  transition: 0.5s;
}
.wc-linked-btn-1:hover .wc-linked-btn-i,
.wc-linked-btn-1:hover .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-linked-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-uplaodrsume-btn-i {
  border-right: 2px solid #fff;
  padding: 8px 9px;
}
.wc-uplaodrsume-btn-1 {
  position: relative;
  color: #84DA28;
  border: 2px solid #84DA28;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  border-right: 2px solid #84DA28;
}
.wc-uplaodrsume-btn-1 .resumeuplad {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .resumeuplad input[type=file] {
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1:hover {
  background: #84DA28;
}
button.close {
  outline: none;
}
input.wc-form-control:focus {
  z-index: 2;
}
.test input[type=text]:focus {
  z-index: 2;
}
@keyframes shimmer {
  0% {
    background-position: -600px 0;
  }
  100% {
    background-position: 600px 0;
  }
}
.sk-box {
  border-radius: 10px;
  background:
    linear-gradient(
      90deg,
      #f0f0f0 25%,
      #e0e0e0 50%,
      #f0f0f0 75%);
  background-size: 1200px 100%;
  animation: shimmer 1.6s infinite linear;
  flex-shrink: 0;
}
.skeleton-page {
  background: #fff;
  border-radius: 8px;
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 100%;
  font-size: 0;
}
.divider {
  height: 1px;
  background: #f0f0f0;
  margin: 8px 0;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.toolbar-actions {
  display: flex;
  gap: 6px;
}
.checkbox {
  width: 16px;
  height: 16px;
  border-radius: 3px;
}
.title-bar {
  width: 180px;
  height: 10px;
}
.icon-btn {
  width: 24px;
  height: 22px;
  border-radius: 4px;
}
.btn-lg {
  width: 110px;
  height: 28px;
  border-radius: 5px;
}
.btn-md {
  width: 80px;
  height: 28px;
  border-radius: 5px;
}
.subtitle-row {
  padding-left: 24px;
  margin-bottom: 6px;
}
.subtitle {
  width: 280px;
  height: 6px;
  border-radius: 10px;
}
.breadcrumb-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 24px;
}
.crumb {
  height: 6px;
  border-radius: 10px;
}
.crumb--sm {
  width: 80px;
}
.crumb--md {
  width: 120px;
}
.crumb--lg {
  width: 180px;
}
.dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  flex-shrink: 0;
}
.chips-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.chip-label {
  width: 90px;
  height: 6px;
}
.chip {
  height: 16px;
  border-radius: 12px;
  min-width: 60px;
}
.data-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.data-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 4px 0;
}
.row-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}
.row-title {
  height: 13px;
  border-radius: 10px;
}
.meta-tag {
  height: 7px;
  border-radius: 10px;
}
.row-meta {
  display: flex;
  align-items: center;
  gap: 6px;
}
.footer-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 4px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.footer-card {
  height: 28px;
  border-radius: 5px;
}
.button {
  height: 28px;
  width: 115px;
  position: relative;
  border-radius: 0px 8px 8px 0px;
  background-color: #f4f4f4;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 4px 12px 4px 0px;
  box-sizing: border-box;
}
.button-child {
  height: 28px;
  width: 16px;
  position: relative;
  flex-shrink: 0;
}
.vector-icon {
  height: 28px;
  width: 100%;
  position: relative;
  background-color: #eeeeee;
}
@media (prefers-reduced-motion: reduce) {
  .sk-box {
    animation: none;
    background: #eeeeee;
  }
}
.table-sk-view,
.table-sk-3-column-view {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  width: 100%;
}
.table-sk-view .table-sk-header,
.table-sk-3-column-view .table-sk-header {
  background: #FAFBFC;
  border-bottom: 1px solid #F2F2F2;
  width: 100%;
  display: flex;
}
.table-sk-view .table-body-row,
.table-sk-3-column-view .table-body-row {
  border-bottom: 1px solid #F2F2F2;
  width: 100%;
  display: flex;
  background-color: #fff;
}
.table-sk-view .table-sk-col,
.table-sk-3-column-view .table-sk-col {
  border-right: 1px solid #F2F2F2;
  padding: 12px 16px;
  width: 30%;
}
.table-sk-view .table-sk-col:last-child,
.table-sk-3-column-view .table-sk-col:last-child {
  border-right: none;
  width: 70%;
}
.table-sk-3-column-view .table-sk-3-col {
  border-right: 1px solid #F2F2F2;
  padding: 12px 16px;
}
.table-sk-3-column-view .table-sk-3-col:last-child {
  border-right: none;
  width: 35%;
}
.table-sk-3-column-view .table-sk-3-col:nth-of-type(2) {
  width: 35%;
}
.table-sk-3-column-view .table-sk-3-col:first-child {
  width: 30%;
}
.scroll-widget {
  height: 350px;
  overflow: auto;
}
.scroll-widget::-webkit-scrollbar {
  width: 4px;
}
.scroll-widget:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
.scroll-widget::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.scroll-widget::-webkit-scrollbar-thumb {
  background: #d1d1d1;
}
.scroll-widget::-webkit-scrollbar-thumb:hover {
  background: #d1d1d1;
}
.emptyScreen {
  width: 100%;
  height: 100vh;
}
.createFirstTalenpool {
  height: 65%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.onhverEdit {
  display: none;
}
.onHover:hover .onhverEdit {
  display: block;
}
.border-bottom-gray {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.border-bottom-gray:last-child {
  border-bottom: none;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}
.border-bottom-gray.mb-3:last-child {
  margin-bottom: 0;
}
.border-bottom-gray.pb-3:last-child {
  padding-bottom: 0;
}
.empty-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}
.line-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip {
  max-width: 500px !important;
  width: 500px !important;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip .mat-mdc-tooltip-surface {
  box-shadow: 0 0 4px 0 #e2e0e0;
  font-family: "Poppins", sans-serif !important;
  font-size: 12px !important;
  font-weight: 400;
  font-family: "Poppins", sans-serif !important;
  max-width: 100% !important;
}
p {
  margin-bottom: 0;
}
h1 {
  font-size: 26px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.58;
  color: #484b59;
  margin-bottom: 60px;
}
.search-input-box {
  border-radius: 7px;
  background-color: #EEF0F2;
  width: 75%;
  padding: 8px 8px;
  display: flex;
  margin: auto;
}
.search-input-box input {
  border-radius: 4px;
  background-color: #fff;
  padding: 7px 10px;
  width: calc(100% - 40px);
  border: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.search-input-box input:focus {
  border: none;
  border-color: none;
}
.search-input-box input:focus-visible {
  outline: none;
  outline-offset: none;
}
.search-input-box .search-btn {
  width: 40px;
  height: 40px;
  background-color: #ffc400;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  color: #ffffff;
}
.newCompCard {
  border-radius: 2px;
  background-color: #fff;
  padding: 15px 15px;
  height: 100%;
}
.newCompCard img {
  width: 70px;
  height: 70px;
}
.compLogoIcon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  font-size: 20px;
  overflow: hidden;
}
.compLogoIcon img {
  height: auto;
  width: 100%;
}
.bg-gray-new {
  background-color: rgba(48, 5, 127, 0.04);
}
.HR-seperator-in-card {
  margin-left: -15px;
  margin-right: -15px;
  border-top: 1px solid #d5dee6;
}
.xsm-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.xsm-icon img {
  width: 100%;
  height: auto;
}
.ml--15 {
  margin-left: -10px;
}
.z1 {
  z-index: 1;
}
.z2 {
  z-index: 2;
}
.z3 {
  z-index: 3;
}
.z4 {
  z-index: 4;
}
.tagslabel {
  border-radius: 13.5px;
  border: solid 0.3px #e3e3e3;
  background-color: #fff;
  padding: 0px 10px 0px 0px;
  margin-right: 10px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  color: #969696;
  margin-bottom: 10px;
  max-width: 210px;
}
.tagslabel .tagicon {
  width: 20px;
  height: 20px;
  flex-grow: 0;
  margin: 0 4px 0 0;
  padding: 5px 4px 3px 5px;
  background-color: rgba(46, 161, 120, 0.1);
  border-radius: 50%;
  color: #2dc3a5;
  display: flex;
}
#container {
  height: 130px;
  position: relative;
  overflow: hidden;
  margin: 0 0px;
}
.photobanner {
  position: absolute;
  top: 0px;
  left: 0px;
  overflow: hidden;
  animation: bannermove 40s linear infinite;
  display: flex;
  height: 100%;
  justify-content: flex-start;
}
.photobanner img {
  margin: 0 0.5em;
}
.photobanner .scrollingdiv {
  width: 440px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@keyframes bannermove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-50%, 0);
  }
}
.companybanner {
  background-image: url(/assets/images/companybanner.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: left top;
  height: 330px;
  margin: -15px;
  padding-top: 40px;
}
.carousel-item {
  width: 100%;
  padding: 0;
}
.carousel-control-prev {
  left: 0;
  top: calc(50% - 15px);
  width: 3% !important;
  height: 30px;
}
.carousel-control-next {
  right: 0;
  top: calc(50% - 15px);
  width: 3% !important;
  height: 30px;
}
.view-history {
  margin-top: 5px;
  display: block;
  margin: auto;
  align-content: center;
  width: 75%;
  color: #2e93a1;
  text-align: right;
  font-size: 14px;
  font-weight: 500;
}
.search-input-box {
  background-color: #ffffff;
  box-shadow: none;
}
.search-input-box input {
  border-radius: 2px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
  box-shadow: none;
}
.search-input-box input:focus {
  border: 1px solid #d9d9d9;
  border-color: #d9d9d9;
}
.search-input-box input:focus-visible {
  outline: none;
  outline-offset: none;
}
.search-input-box .search-btn {
  box-shadow: none;
}
.bb {
  border-bottom: 1px solid #d5dee6;
}
.test1 {
  display: block;
}
.test2 {
  display: none;
}
button.collapsed .test1 {
  display: none;
}
button.collapsed .test2 {
  display: block;
}
.wc-ats-chip {
  padding: 5px 15px;
  background-color: #fafbfc;
  font-size: 14px;
  border-radius: 16px;
  display: inline-flex;
}
.wc-ats-chip span i {
  font-size: 14px;
  color: #484b59;
}
.wccard div.bb:last-child {
  border-bottom: none;
}
.ats-dropBtn .dropdown-toggle::after {
  display: none;
}
.ats-dropBtn .btn-break {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn .isActive {
  color: #2e93a1 !important;
}
.ats-dropBtn .dropdown-menu {
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
}
.ats-dropBtn .dropdown-menu a.dropdown-item:hover {
  color: #4A90E2;
  background-color: #EBF0F4;
}
.ats-dropBtn .dropdown-menu.show {
  transform: translate3d(-40px, 15px, 0px) !important;
  top: 8px;
}
.search-history-btn {
  color: #2e93a1;
  cursor: pointer;
  text-decoration: underline;
  width: 87%;
  text-align: right;
  font-size: 14px;
  font-weight: 500;
}
::ng-deep .mat-mdc-header-cell {
  overflow: visible;
}
.fa-linkedin {
  color: #0652ba;
}
.fa-square-x-twitter {
  color: #000;
}
.fa-facebook {
  color: #0652ba;
}
.comp-cta1 {
  width: 27px;
  height: 27px;
  border-radius: 2.2px;
  background-color: #e1f4f1;
  color: #2e93a1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-pills .nav-link {
  border-radius: 3px;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  font-size: 12px;
  padding: 10px 12px;
  color: #2e93a1;
}
.nav-pills .nav-link:focus-visible {
  outline: none;
  border: none;
}
.nav-pills .nav-link:focus-within {
  outline: none;
  border: 1px solid #ffffff;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #2e93a1;
  font-weight: bold;
  background-color: #e4f1f3;
  border: solid 1px #2e93a1;
  font-size: 12px;
  font-weight: 600;
}
.nav-pills .nav-link.active:focus-visible,
.nav-pills .show > .nav-link:focus-visible {
  outline: none;
}
.nav-pills .nav-link.active:focus-within,
.nav-pills .show > .nav-link:focus-within {
  outline: none;
}
.text-afaf {
  color: #afafaf;
}
.summarybox {
  border-radius: 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
  padding: 15px 15px;
}
.col.borderRight {
  position: relative;
}
.col.borderRight::after {
  content: "";
  width: 1px;
  height: 40px;
  background-color: #d5dee6;
  display: flex;
  position: absolute;
  top: 5px;
  right: 0;
}
.lablePercent {
  padding: 4px 4px;
  border-radius: 3px;
  background-color: #e4f1f3;
  color: #02af02;
  display: inline-block;
  margin-left: 10px;
}
.textBox {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.textBox2 {
  max-height: 25px;
  overflow: hidden;
}
.viewMore {
  overflow: visible;
  -webkit-line-clamp: unset;
}
.viewMore2 {
  overflow: visible;
  height: auto;
  max-height: unset;
}
.textBox p {
  line-height: 1.5;
}
.topsticky {
  position: sticky;
  top: 15px;
  background-color: #fff;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.topsticky::before {
  content: "";
  display: block;
  background-color: #fafbfc;
  height: 15px;
  width: 100%;
  position: absolute;
  top: -15px;
}
.stickytop {
  position: sticky;
  top: 15px;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.stickytop::before {
  content: "";
  display: block;
  background-color: #fafbfc;
  height: 15px;
  width: 100%;
  position: absolute;
  top: -15px;
}
.company-details-filter-sticky {
  position: sticky;
  top: 15px;
  height: calc(100vh - 30px);
  overflow-y: auto;
}
.company-details-filter-sticky::-webkit-scrollbar {
  width: 4px;
}
.company-details-filter-sticky:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
.company-details-filter-sticky::-webkit-scrollbar-track {
  background: white !important;
}
.company-details-filter-sticky::-webkit-scrollbar-thumb {
  background: #ccc;
}
.company-details-filter-sticky::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
::ng-deep .company-details-filter-sticky app-person-search-filter .onscrollStickTop {
  top: 0px !important;
}
.company-details-tabs {
  position: sticky;
  top: 15px;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.company-details-tabs::before {
  content: "";
  display: block;
  background-color: #fafbfc;
  height: 15px;
  width: 100%;
  position: absolute;
  top: -15px;
}
.bg-input {
  width: 85%;
  color: #484b59;
  background-color: #eaeaea !important;
  border: 1px solid #ecf0f4;
  border-radius: 2px;
  padding: 10px;
}
@media screen and (max-width: 1920px) {
  .bg-input {
    width: 90%;
  }
}
@media screen and (max-width: 1680px) {
  .bg-input {
    width: 89%;
  }
}
@media screen and (max-width: 1440px) {
  .bg-input {
    width: 87%;
  }
}
@media screen and (max-width: 1366px) {
  .bg-input {
    width: 86%;
  }
}
@media screen and (max-width: 1280px) {
  .bg-input {
    width: 84%;
  }
}
@media screen and (max-width: 1024px) {
  .bg-input {
    width: 83%;
  }
}
.bq-div {
  width: calc(100% - 200px);
}
.w-200px {
  width: 200px;
  display: flex;
  align-items: center;
}
.copy-btn {
  padding: 10px 20px;
  position: absolute;
  left: 0;
  top: -21px;
}
.btn-position {
  position: absolute;
  right: -10px;
  width: 95px;
}
.boolean-input {
  overflow: hidden;
  line-height: 1.3;
  resize: none;
}
.copy-btn-search {
  padding: 7px;
  width: 90px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #ecf0f4;
  border-left: none;
}
.sticky-box {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  margin-bottom: 15px;
}
.w-100px {
  width: 130px;
}
.circular-img {
  width: 59px;
  height: 59px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 600;
}
.rightsideclose.mat-chip.mat-standard-chip {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-direction: row-reverse;
}
.isActive {
  color: #2e93a1 !important;
}
.card {
  border-left: none;
  border-right: none;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.card-header {
  padding: 0.5rem 0;
  margin-bottom: 0;
  background-color: hsla(0, 0%, 100%, 0.03);
  border-bottom: none;
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
.collapse:not(.show) {
  display: none;
}
.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
.btn-link {
  font-weight: 400;
  text-decoration: none;
  color: #484b59;
}
.btn-link .wcAccordianUpDownArrow .test1 {
  display: block;
  transition: display 0.4s;
}
.btn-link .wcAccordianUpDownArrow .test2 {
  display: none;
  transition: display 0.4s;
}
.btn-link .collapsed + .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.btn-link .collapsed + .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.btn-link .collapsed .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.btn-link .collapsed .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.collapsed {
  color: #484b59;
}
.collapsed + .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.collapsed + .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.collapsed .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.collapsed .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.wcAccordianUpDownArrow {
  right: 0;
  justify-self: flex-end;
}
.underline-on-hover:hover {
  text-decoration: underline;
  cursor: pointer;
}
.show-on-hover {
  display: none;
}
.hoverable-element:hover .show-on-hover {
  display: block;
}
.add-to-talentpool {
  padding-top: 7px;
  padding-bottom: 7px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 4px;
  border: solid 0.5px #2e93a1;
  background-color: #ffffff;
  padding: 6px 12px;
  height: 35px;
}
.reset-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  background-color: #969696;
  color: #fff;
}
.static ~ .toggle .up {
  display: block;
}
.static ~ .toggle .down {
  display: none;
}
.static.collapsed ~ .toggle .up {
  display: none;
}
.static.collapsed ~ .toggle .down {
  display: block;
}
.empty-state-img {
  width: 138.92px;
  height: 177.81px;
}
.new-form {
  width: 125px;
  height: 25px;
  padding: 1px 6px 2px 4px;
  border-radius: 4px;
  border: solid 1px #d5dee6;
  background-color: #fff;
}
.wc-form-control:focus {
  border-color: #2E93A1;
  outline: none;
}
.new-form:focus {
  border-color: #2E93A1;
  outline: none;
}
.f-13 {
  font-size: 13px;
  line-height: 1.3;
}
.mat-chip.mat-standard-chip .mat-chip-remove {
  color: rgba(0, 0, 0, 0.87);
  opacity: inherit !important;
}
.excluded-chip {
  background-color: #fae7e7 !important;
}
#overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 6;
  top: 0;
  left: 0px;
  background-color: #000;
  opacity: 0.4;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 30px;
  display: none;
}
#quickView {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 6;
  top: 0;
  right: -60px;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 0px 0px;
}
.male-box {
  height: 8px;
  flex-grow: 0;
}
ul {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.lavender-circle {
  background-color: #E1D8E9 !important;
  color: #725190 !important;
}
.yellow-circle {
  background-color: #FFF9D7 !important;
  color: #E0BF00 !important;
}
.blue-circle {
  background-color: #B9D4F4;
  color: #1C5FB0;
}
.pink-circle {
  background-color: #FBDAE7;
  color: #A5124D;
}
.teal-circle {
  color: #34A853;
  background-color: #EBF6EE;
}
::ng-deep .mat-table {
  font-family: "Poppins", sans-serif !important;
}
.skills-chip {
  background-color: #e4f1f3;
  border-radius: 16px;
  min-height: 26px;
  font-weight: 500;
  font-size: 12px;
}
.hoverToShowGuideline {
  cursor: pointer;
}
.hoverToShowGuideline:hover i {
  color: #2e93a1;
}
.hoverToShowGuideline:hover .searchGuide {
  width: calc(100% - 125px);
  display: block;
  transition: display 0.5s;
}
.hoverToShowGuideline:hover .searchResutlBackdrop {
  display: block;
}
.searchGuide {
  width: 100%;
  background-color: white;
  display: none;
  transition: display 0.5s;
  position: fixed;
  top: 70px;
  left: 95px;
  padding: 20px;
  z-index: 4;
  text-align: left;
}
.hoverable-class:hover {
  cursor: pointer;
}
.red-dot {
  color: #CD0F0F;
  font-size: 28px;
  line-height: 1;
}
.loader {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader img {
  width: 60px;
}
.loader.small {
  height: 200px;
}
.loader.medium {
  height: 365px;
}
.loader.big {
  height: 400px;
}
#top2,
#viewless2,
#top4,
#viewless4 {
  display: none;
}
.ml-8 {
  margin-left: 35px;
}
.save-search-btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border: solid 0.5px #2E93A1;
  background-color: #fff;
  padding: 8px 20px;
  white-space: nowrap;
  border-radius: 3px;
}
.newCompCard {
  border-radius: 2px;
  background-color: #fff;
  padding: 15px 15px;
  height: 100%;
}
.newCompCard img {
  width: 70px;
  height: 70px;
}
.compLogoIcon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e4f1f3;
  margin-right: 15px;
  font-size: 20px;
  overflow: hidden;
}
.compLogoIcon img {
  width: 100%;
  height: auto;
}
.dstooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.dstooltip-content {
  display: none;
  position: absolute;
  min-width: 360px;
  width: 360px;
  box-shadow: 0 4px 10px 0 rgba(46, 147, 161, 0.2);
  top: 18px;
  z-index: 1;
}
.dstooltip:hover .dstooltip-content {
  display: block;
}
.dropup:hover .dropbtn {
  background-color: #2980B9;
}
.chipsnew {
  background-color: #e4f1f3;
  border-radius: 18px;
  font-size: 12px;
  font-weight: 500;
  padding: 3px 6px;
  max-width: 150px;
  width: 150px;
  margin-bottom: 5px;
}
.disabled {
  background-color: gray;
  cursor: default;
}
.containerheight {
  height: 88vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.filterScrollFix {
  height: 97vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: sticky;
  top: 0;
  z-index: 1;
}
.sticky-box {
  position: relative;
  width: 100%;
  height: 42vh;
  overflow-y: scroll;
  margin-bottom: 15px;
}
.filterScrollFix::-webkit-scrollbar {
  width: 4px;
}
.filterScrollFix:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
.filterScrollFix::-webkit-scrollbar-track {
  background: white !important;
}
.filterScrollFix::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
.filterScrollFix::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.talentCountFixonScroll {
  position: sticky;
  top: 0px;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.onscrollStickTop {
  position: sticky;
  top: 0;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.ats-dropBtn .dropdown-menu {
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
}
.ats-dropBtn .dropdown-menu a.dropdown-item:hover {
  color: #969696;
  background-color: #EBF0F4;
}
.btn-break {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.card-data {
  height: 130px;
}
.dropdown-toggle::after {
  border-top: none;
}
.four-matrix {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
  padding: 5px 18px;
  cursor: pointer;
}
.four-matrix p {
  color: #969696;
}
.four-matrix:hover {
  background-color: #f2f2f2;
}
.four-matrix:hover p {
  color: var(--Primary-Text);
}
.changedJobs {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
}
.changedJobs-matrix {
  width: 100%;
  padding: 5px 18px;
  cursor: pointer;
}
.changedJobs-matrix p {
  color: #969696;
}
.changedJobs-matrix:hover {
  background-color: #f2f2f2;
}
.changedJobs-matrix:hover p {
  color: var(--Primary-Text);
}
.selectInMatrix {
  font-size: 12px;
  padding: 5px 18px;
  width: 100%;
  border: none;
  color: #969696;
  border-radius: 4px;
}
.diversity-matrix {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
  cursor: pointer;
}
.gender-ratio {
  width: 50%;
  padding-top: 8px;
  padding-bottom: 2px;
  cursor: pointer;
}
.gender-ratio p {
  color: #969696;
}
.gender-ratio:hover {
  background-color: #f2f2f2;
}
.gender-ratio:hover p {
  color: var(--Primary-Text);
}
.gender {
  text-align: center;
}
.redirect-report {
  background-image: url(/assets/redirect-bg.png);
}
.redirect-filter {
  padding: 4px 12px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  border: solid 1px #d9d9d9;
}
.redirect-filter-others {
  color: #484b59;
  font-size: 14px;
}
.redirect-dot {
  width: 4px;
  height: 4px;
  flex-grow: 0;
  background-color: #969696;
}
.headerbg {
  background-color: #fff;
  background-image: url("./media/headerbg-YKGJQXIS.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top;
  height: 100%;
  border-radius: 4px;
}
.similar-candidate-chip {
  border-radius: 30px;
  border: 1px solid var(--Box-Border, #D9D9D9);
  background: #FFF;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: 400;
}
.containerheight {
  height: 88vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.filterScrollFix {
  height: 97vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: sticky;
  top: 0;
  z-index: 1;
}
.sticky-box {
  position: relative;
  width: 100%;
  height: 42vh;
  overflow-y: scroll;
  margin-bottom: 15px;
}
.filterScrollFix::-webkit-scrollbar {
  width: 4px;
}
.filterScrollFix:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
.filterScrollFix::-webkit-scrollbar-track {
  background: white !important;
}
.filterScrollFix::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
.filterScrollFix::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.talentCountFixonScroll {
  position: sticky;
  top: 0px;
  z-index: 1;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.onscrollStickTop {
  position: sticky;
  top: 0;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.ats-dropBtn .dropdown-menu {
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
}
.ats-dropBtn .dropdown-menu a.dropdown-item:hover {
  color: #969696;
  background-color: #EBF0F4;
}
.btn-break {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.card-data {
  height: 130px;
}
.dropdown-toggle::after {
  border-top: none;
}
.four-matrix {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
  padding: 5px 18px 8px 18px;
  cursor: pointer;
}
.four-matrix p {
  color: #969696;
}
.four-matrix:hover {
  background-color: #f2f2f2;
}
.four-matrix:hover p {
  color: var(--Primary-Text);
}
.diversity-matrix {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
  cursor: pointer;
}
.gender-ratio {
  width: 50%;
  padding-top: 8px;
  padding-bottom: 2px;
  cursor: pointer;
}
.gender-ratio p {
  color: #969696;
}
.gender-ratio:hover {
  background-color: #f2f2f2;
}
.gender-ratio:hover p {
  color: var(--Primary-Text);
}
.gender {
  text-align: center;
}
.redirect-report {
  background-image: url(/assets/redirect-bg.png);
}
.redirect-filter {
  padding: 4px 12px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  border: solid 1px #d9d9d9;
}
.redirect-filter-others {
  color: #484b59;
  font-size: 14px;
}
.redirect-dot {
  width: 4px;
  height: 4px;
  flex-grow: 0;
  background-color: #969696;
}
.headerbg {
  background-color: #fff;
  background-image: url("./media/headerbg-YKGJQXIS.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top;
  height: 100%;
  border-radius: 4px;
}
.similar-candidate-chip {
  border-radius: 30px;
  border: 1px solid var(--Box-Border, #D9D9D9);
  background: #FFF;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: 400;
}
.card-img {
  width: 120px;
  height: 100%;
  margin: 50.9px 60px 11px 3px;
  object-fit: contain;
}
.item {
  width: 190px;
  height: 60px;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn .dropdown-toggle::after {
  border-top: none;
  outline: none;
}
.ats-dropBtn .dropdown-menu.show {
  border: none;
  transform: translate3d(-44px, 26px, 0px) !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
  padding: 0;
  width: fit-content;
  padding: 18px;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #fff;
}
.ats-dropBtn.slider-drop .dropdown-menu.show {
  transform: translate3d(-213px, 26px, 0px) !important;
  padding: 8px 0 !important;
}
.region-box {
  width: 160px;
  height: 90px;
  border-radius: 4px;
  overflow: hidden;
}
.border-blue {
  border: 2px solid #2e93a1;
}
.border-gray {
  border: 1px solid #cacaca;
}
.spinner-border {
  width: 1rem;
  height: 1rem;
  z-index: 3;
}
.logobgcolor {
  background-color: rgba(48, 5, 127, 0.04);
}
.dumy-placeholder {
  position: absolute;
  bottom: 20px;
  left: 20px;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: #8a8682;
  z-index: 0;
  line-height: 1.3;
}
.default-placeholder {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: #8a8682;
  line-height: 1.3;
}
.filters-tooltip-content {
  display: none;
  position: absolute;
  bottom: 1.875rem;
  right: 0;
  background-color: #fff;
  text-wrap: nowrap;
  width: fit-content;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  z-index: 5;
  padding: 0.5rem 0;
}
.dstooltip:hover .filters-tooltip-content {
  display: block;
}
.filters-tooltip-content div {
  position: relative;
  margin-left: -5px;
}
.hiderule:last-child > hr {
  display: none;
}
.dot {
  width: 4px;
  height: 4px;
  background-color: #484b59;
  border-radius: 50%;
  position: absolute;
  left: 19px;
  top: 8px;
}
.hl-mssg {
  margin: 0 1rem;
  margin-left: 1.5rem;
  display: inline-block;
  padding: 0 8px;
  line-height: 1.5;
}
.ai-text-gradient {
  background-image:
    linear-gradient(
      251deg,
      #c845ab 85%,
      #e24e7f 48%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.sim-can-edit-btn {
  width: 74px;
  height: 29px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 4px 12px;
  border-radius: 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
  color: #484b59;
}
.sim-can-edit-btn:focus {
  outline: none;
}
::-webkit-scrollbar {
  width: 4px;
}
:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
::-webkit-scrollbar-track {
  background: white !important;
}
::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.ai-suggestions-header {
  height: 25px;
  flex-grow: 0;
  background-image: url("./media/gradient-Q42PCSKJ.png");
  position: relative;
  background-repeat: no-repeat;
  background-size: 200px 50px;
}
.gtext {
  position: absolute;
  color: #100f0f;
  position: absolute;
}
.suggestion-chips {
  max-width: 200px;
  height: 30px;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 18px;
  border: solid 1px #969696;
  background-color: #fff;
}
.isSelected {
  border: solid 1px #2e93a1;
  color: #2e93a1;
}
.disable-btn {
  cursor: not-allowed;
  background-color: #f2f2f2;
  color: #969696;
}
.enable-btn {
  cursor: pointer;
  background-color: #e4f1f3;
  color: #2e93a1;
  border: solid 1px #2e93a1;
}
.ai-container-box {
  border-style: solid;
  border-width: 1px;
  border-image-source:
    linear-gradient(
      250deg,
      #c845ab 85%,
      #e24e7f 48%);
  border-image-slice: 1;
}
.page-selection {
  color: #484b59;
  position: absolute;
  right: 0;
  margin-right: 30px;
}
.page-selection select {
  gap: 4px;
  margin: 0 7px 0 6px;
  padding: 4px 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
}
.sticky-pagination {
  position: sticky;
  bottom: 0;
}
.chip-container {
  max-height: 60px;
  overflow: hidden;
}
.chip-container.expanded {
  max-height: none;
}
.talentpool-insights {
  background-size: contain, 186px 202px;
  background-repeat: no-repeat, no-repeat;
  background-position: left top, bottom right;
  height: 100%;
  border-radius: 4px;
}
.talentpool-insights div.p40 {
  padding: 40px;
}
.talentpool-insights div.pr40 {
  padding-right: 40px;
}
.talentpool-insights div.pl40 {
  padding-left: 40px;
}
.talentpool-insights .br1 {
  border-right: 1px solid #d9d9d9;
}
.talentpool-insights .w-100 .wc-form-control {
  border: 1px solid #d9d9d9;
  padding: 3px 9px;
  height: 36px;
}
.talentpool-insights .text-342a29 {
  color: #342a29;
}
.talentpool-insights .f-44 {
  font-size: 44px;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn .dropdown-toggle::after {
  border-top: none;
  outline: none;
}
.ats-dropBtn .dropdown-menu.show {
  border: none;
  transform: translate3d(-350px, 30px, 0px) !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
  padding: 0;
  width: 375px;
  padding: 18px;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #fff;
}
.region-box {
  width: 160px;
  height: 90px;
  border-radius: 4px;
  overflow: hidden;
}
.border-blue {
  border: 2px solid #2e93a1;
}
.border-gray {
  border: 1px solid #cacaca;
}
.disabled-button {
  pointer-events: none;
  border: none;
  background-color: #cccccc;
  cursor: not-allowed;
  flex-direction: row;
}
.wc-btn {
  padding: 7px 21px;
  color: #ffffff;
  font-weight: 100;
  border-radius: 3px;
  outline: none;
  border: none;
  cursor: pointer;
  width: 130px;
}
.disabled-input {
  background-color: #eaeaea !important;
}
.enable-input {
  pointer-events: pointer;
}
.talent-count {
  margin-bottom: 8px;
  padding: 24px 0 0px 26px;
  border-radius: 8px;
  box-shadow: 0 5px 5px 0 rgba(108, 105, 105, 0.1);
  border: solid 1px #d5dee6;
  background-color: #fff;
}
.talent-jd {
  margin-bottom: 8px;
  padding: 24px 0 0px 20px;
  border-radius: 8px;
  box-shadow: 0 5px 5px 0 rgba(108, 105, 105, 0.1);
  border: 1px solid #d5dee6;
  background:
    linear-gradient(
      271deg,
      #ebf9ff -4.48%,
      #ffe3ff 90.29%);
  color: #484b59;
}
.talent-count-background {
  background-image: url("./media/advance-character-1-KTJ626DV.png");
  background-repeat: no-repeat;
  background-position-x: right;
  background-size: contain;
  height: 100%;
}
.search-history {
  border-radius: 8px;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #d9d9d9;
  background-color: #fff;
  margin: 8px 0px;
}
.quickSearch {
  padding: 12px 16px;
}
.nav-pills .nav-link {
  border-radius: 3px;
  background-color: transparent;
  color: #2C2C2C;
  font-size: 14px;
  padding-left: 16px;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #206C79;
  border-radius: 0px;
  font-size: 14px;
  padding-left: 16px;
  border: none;
  font-weight: 500;
  background-color: transparent;
}
.insights-header {
  padding: 20px 16px;
  font-size: 32px;
  font-weight: 600;
  color: #484b59;
  background-color: #e8f2f7;
  height: 130px;
  border-radius: 4px;
}
.insights-header p {
  background: -webkit-linear-gradient(132deg, #BD38EB 57.52%, #E24E7F 90.29%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.headerbg {
  background-color: #fff;
  background-image: url("./media/headerbg-YKGJQXIS.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top;
  height: 115px;
  border-radius: 4px;
}
.topsticky2 {
  position: sticky;
  top: 15px;
  z-index: 1;
  height: 85vh;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: none;
}
.topsticky2::-webkit-scrollbar {
  width: 4px;
}
.topsticky2:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
.topsticky2::-webkit-scrollbar-track {
  background: white !important;
}
.topsticky2::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
.topsticky2::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.jd-edit-btn {
  height: 31px;
  padding: 7px 10px;
  border-radius: 4px;
  border: solid 1px #2e93a1;
  background-color: #E4F1F3;
  color: #2e93a1;
}
.jd-edit-btn:focus {
  outline: none;
}
/*# sourceMappingURL=report-details.component-EX6FP5KY.css.map */
